module.exports = __webpack_public_path__ + "static/media/5.58fa897e.JPG";